import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { Link, LinkProps } from '@mui/material';
import _ from 'lodash';

export type AppLinkProps = LinkProps | RouterLinkProps;

export default function AppLink(props: AppLinkProps) {
  const derivedProps = _.merge({ sx: { color: 'black' } }, props);
  return (
    <Link component={RouterLink} {...derivedProps}>
      {props.children}
    </Link>
  );
}
